import React from "react";

import { Impulse } from "~/tools/impulse";
import { usePermanent } from "~/tools/use-permanent";

import { SouthPaneContext, type SouthPaneState } from "./_context";

export const SouthPaneProvider: React.FC<
	React.PropsWithChildren<{
		state?: SouthPaneState;
	}>
> = ({ state, children }) => {
	const fallback = usePermanent<SouthPaneState>(() => ({
		isOpen: Impulse(true),
	}));

	return <SouthPaneContext.Provider value={state ?? fallback}>{children}</SouthPaneContext.Provider>;
};
